module.exports = __webpack_public_path__ + "static/images/enter-game-bg2.bdbf256.png";